import noImage from '../../img/nophotoproduct.jpg'

export const dummyBrand = {
    description: '<p>This is a brand description element. Description for a brand can be changed from Brands Page in the backoffice. Brands Page link is available from left menu.</p>',
    image: noImage,
    name: "Your brand's title",
}